import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../../environments/environment';
import { ENDPOINT } from '../../routes/end-points';
import { GetUnverfiedCustomerResponse, GetUnverfiedPrimerResponse } from './sidebar.types';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private socket: Socket;

  constructor(private service:ApiService) { 
    this.socket = io(`${environment.BASEURL}user`);
  }

  getUnverifiedPrimer() {
    return this.service.get<GetUnverfiedPrimerResponse>(environment.BASEURL + ENDPOINT.SIDEBAR.GETUNVERIFIEDPRIMER);
  }

  getUnverifiedCustomer() {
    return this.service.get<GetUnverfiedCustomerResponse>(environment.BASEURL + ENDPOINT.SIDEBAR.GETUNVERIFIEDCUSTOMER);
  }


  getMessages(socket: string): Observable<any> {
    return new Observable((observer) => {
      this.socket.on(socket, (message: any) => {
        observer.next(message);
      });
    });
  }
}
